import { ButtonStyled } from '@nike/nike-design-system-components';
import { CaretRight, CaretLeft } from '@nike/nike-design-system-icons';
import { Maybe } from '@nike/rcf-fp';
import PropTypes from 'prop-types';
import React from 'react';

import { useGetLocalization } from '../../hooks';

function ButtonDirection({
  appearance,
  ariaLabel,
  buttonClassName,
  direction,
  id,
  isDisabled,
  onClick,
  sectionClassName,
  size,
}) {
  const getLocalization = useGetLocalization();
  const effectiveAriaLabel = Maybe.of(ariaLabel).orElseGet(() => getLocalization('lbl.button'));
  return (
    <section className={sectionClassName}>
      <ButtonStyled
        appearance={appearance}
        ariaLabel={effectiveAriaLabel}
        className={buttonClassName}
        disabled={isDisabled}
        id={id}
        size={size}
        type="button"
        onClick={onClick}
      >
        {direction === 'left' ? <CaretLeft /> : <CaretRight />}
      </ButtonStyled>
    </section>
  );
}

ButtonDirection.defaultProps = {
  appearance: 'secondary',
  buttonClassName: 'mb2-sm',
  id: '',
  isDisabled: false,
  sectionClassName: '',
  size: 'small',
};

ButtonDirection.propTypes = {
  appearance: PropTypes.string,
  ariaLabel: PropTypes.string.isRequired,
  buttonClassName: PropTypes.string,
  direction: PropTypes.string.isRequired,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  sectionClassName: PropTypes.string,
  size: PropTypes.string,
};

export default ButtonDirection;
